import * as d3 from 'd3'
import Defs from '../../../../includes/primitives/colorDefs'

export default {
  methods: {

    Chart_Gauge(selection) {

      let circle = this.circle
      let grid = this.circle.grid
      let needle = this.circle.needle
      let endAn = ''
      let progValue = this.rawData.PROG

      Defs.setDefs_Reflections(selection, this.localId)
      Defs.setDefs_Gradients(selection, 0, 'LinearA4', needle.color, [1, 1, -.5, -.5], this.localId)
      Defs.setDefs_Gradients(selection, 1, 'LinearA4', needle.color, [0, 0.5, 1, 0.5], this.localId)
      Defs.setDefs_Gradients(selection, 2, 'LinearA2', needle.color, [1,1,1,1], this.localId)

      let gauge = selection
      .append('g')
      .attr('transform', `translate(${circle.x + circle.radius},${circle.y + circle.radius})`)

      // Gauge Gride - Background
      var arcBg = d3.arc()
      .innerRadius(circle.radius)
      .outerRadius(circle.radius - circle.thick)
      .startAngle(this.angle.start * Math.PI / 180)
      .endAngle(this.angle.end * Math.PI / 180)

      gauge
      .append("path")
      .attr("d", arcBg)
      .attr('fill', grid.sColor)
      .attr('opacity', grid.opacity)
      .attr('transform', `translate(${0}, ${0})`)

      // Gauge Gride - white
      let st = 0
      let an = this.angle.size
      let ro = an / 64
      let Y1 = -circle.radius 
      let Y2 = Y1 + circle.thick
      st = this.angle.start
      an = this.angle.end
      
      for (var n = st;n <= an;n += ro) {
        gauge
        .append('line')
        .attr('x1', 0).attr('y1', Y1)
        .attr('x2', 0).attr('y2', Y2)
        .attr('stroke', 'white').attr('stroke-width', grid.sWidth)
        .attr('transform', () => `rotate(${n},${0},${0})`)
      }

      // Draw Front Chart
      let arc = d3.arc()
      .outerRadius(circle.radius)
      .innerRadius(circle.radius - circle.thick)
      .startAngle(this.angle.start * Math.PI / 180)
      .endAngle(() => endAn || this.angle.start * Math.PI / 180)

      gauge
      .append('path')
      .attr('d', arc)
      .attr('fill', circle.color)
      .attr('opacity', circle.opacity)
      .attr('transform', `translate(0, 0)`)
      .transition()
      .duration(750)
      .attrTween('d', ()=> {
        let endAngle_ = ( ((this.angle.size * (this.rawData.PROG/100)) + this.angle.start) * Math.PI / 180)
        let interpolate = d3.interpolate(this.angle.start * Math.PI / 180, endAngle_)
        return function(t) {
          endAn = interpolate(t)
          return arc();
        }
      })
      

      // needle
      let needleLen = circle.radius - circle.thick
      let needleRadius = 5
      let centerX = 0
      let centerY = 0

      let percent = 0
      let thetaRad = percent * Math.PI

      let topX = centerX - needleLen * Math.cos(thetaRad)
      let topY = centerY - needleLen * Math.sin(thetaRad)

      let leftX = centerX - needleRadius * Math.cos(thetaRad - Math.PI / 2)
      let leftY = centerY - needleRadius * Math.sin(thetaRad - Math.PI / 2)

      let rightX = centerX - needleRadius * Math.cos(thetaRad + Math.PI / 2)
      let rightY = centerY - needleRadius * Math.sin(thetaRad + Math.PI / 2)

      gauge
      .append('path')
      .attr('id', `needle_${this.localId}`)
      .attr('d', `M ${leftX} ${leftY} L ${topX} ${topY} L ${rightX} ${rightY}`)
      .attr('fill', `url(#${this.localId}_${needle.color}_0)`)

      d3.select(`#needle_${this.localId}`)
      .transition().duration(750)
      .attr('transform', `translate(0,0) rotate(${(progValue/100) * 180})`)

      gauge
      .append('circle').attr('cx', 0).attr('cy', 0).attr('r', 5).attr('fill', `url(#${this.localId}_${needle.color}_1)`)
      gauge
      .append('circle').attr('cx', 0).attr('cy', 0).attr('r', 2).attr('fill', `url(#${this.localId}_${needle.color}_2)`)

      if(this.circle.grid.visible == "N"){

      }else{
        // Grid - Text
        gauge
        .append('text')
        .attr('transform', `translate(${0 - circle.radius - 3}, ${grid.tSize*0.36})`)
        .style('font-size', grid.tSize).attr('fill', grid.tColor).attr('text-anchor', 'end')
        .text('0%')

        gauge
        .append('text')
        .attr('transform', `translate(${(circle.radius + 3) * Math.sin((270-45) * Math.PI/180)},${(circle.radius + 3)  * Math.cos((270-45) * Math.PI/180) + grid.tSize*0.36})`)
        .style('font-size', grid.tSize).attr('fill', grid.tColor).attr('text-anchor', 'end')
        .text('25%')

        gauge
        .append('text')
        .attr('transform', `translate(0, ${0 - circle.radius - 7 + grid.tSize*0.36})`)
        .style('font-size', grid.tSize).attr('fill', grid.tColor).attr('text-anchor', 'middle')
        .text('50%')

        gauge
        .append('text')
        .attr('transform', `translate(${(circle.radius + 3) * Math.sin((270-135) * Math.PI/180)},${(circle.radius + 3)  * Math.cos((270-135) * Math.PI/180) + grid.tSize*0.36})`)
        .style('font-size', grid.tSize).attr('fill', grid.tColor).attr('text-anchor', 'start')
        .text('75%')

        gauge
        .append('text')
        .attr('transform', `translate(${circle.radius + 3}, ${grid.tSize*0.36})`)
        .style('font-size', grid.tSize).attr('fill', grid.tColor).attr('text-anchor', 'start')
        .text('100%')
      }
        
        // Progress(%)
        let col = this.columns.find(f=> f.code == 'PROG')
        gauge
        .append('text')
        .attr('transform', `translate(0, ${needle.proY + col.tSize*0.36})`)
        .attr('font-size', col.tSize).attr('fill', col.tColor)
        .attr('text-anchor', 'middle')
        .transition().duration(750)
        .tween("text", function() {
          var i = d3.interpolateNumber(1, progValue)
          return function(t) {
          d3.select(this).text( `${Number(i(t).toFixed(1))}%` )
          }
        })
    },

    
  }
}